export default {"src":"/_next/static/media/US.63eb09ff.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};